/**
 * @velyn-custom BEGIN — vely-mobile-menu-accordion.js
 * menu-drawer level-2: one open accordion at a time (Figma mobile mega menu).
 */
(function () {
  const MOBILE_MAX = 1024;

  function isMobileMenu() {
    return window.innerWidth <= MOBILE_MAX;
  }

  function closeSiblingAccordions(details) {
    const list = details.closest(".menu");
    if (!list) return;

    list.querySelectorAll('details.vely-mobile-menu-accordion[open]').forEach((item) => {
      if (item !== details) {
        item.open = false;
      }
    });
  }

  function onSummaryClick(event) {
    if (!isMobileMenu()) return;

    const summary = event.target.closest("summary");
    const details = summary?.closest("menu-drawer details.vely-mobile-menu-accordion");
    if (!details) return;

    window.setTimeout(() => {
      if (details.open) {
        closeSiblingAccordions(details);
      }
    }, 0);
  }

  document.addEventListener("click", onSummaryClick, true);

  document.addEventListener("shopify:section:load", () => {
    /* menu-drawer is cloned on open; delegation handles new nodes */
  });
})();

/** @velyn-custom END — vely-mobile-menu-accordion.js */
